module.exports = __webpack_public_path__ + "img/About_9.6681d743.png";